import axios from 'axios';

export const API = {

    server(){
        return window.location.protocol 
            + '//'
            + window.location.hostname
    },

    url(path){
        return this.server()
            + '/api/v2'
            + path
    },

    async get(path, options){
        const url = API.url(path);
        return await axios.get(url, options);
    },

    async post(path, data, options){
        const url = API.url(path);
        return await axios.post(url, data, options);
    },

    async put(path, data, options){
        const url = API.url(path);
        return await axios.put(url, data, options);
    },

    async delete(path, options){
        const url = API.url(path);
        return await axios.delete(url, options);
    },

    async getCourses(){
        const url = API.url('/courses');
        return await axios.get(url);
    },

    async getOrigins(){
        const url = API.url('/origins');
        return await axios.get(url);
    },

    async getCourse(id){
        const url = API.url('/courses/'+ id);
        return await axios.get(url);
    },

    async getCategories(){  
        const url = API.url('/categories');
        return await axios.get(url);
    },

    async enrollForFree(id){  
        const url = API.url(`/courses/${id}/free`);
        return await axios.get(url);
    },

    async sendOpcoEmail(id){  
        const url = API.url(`/courses/${id}/opco`);
        return await axios.get(url);
    },
    
    async downloadFile(url, fileName){

        try{
            const r = await axios({url: url, method: 'GET', responseType: 'blob'});

            const href = URL.createObjectURL(r.data);
        
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', fileName || 'file');
            document.body.appendChild(link);
            link.click();
        
            document.body.removeChild(link);
            URL.revokeObjectURL(href);

            return true;

        }catch(e){
            console.log(e);
            return false;
        }
    }

};


export default API;